/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui'

import {
  incognitoModeEnabledAtom,
  otpQuickLoginEnabledAtom,
  userReceivedAction,
} from './reatom-user'
import { updateUserSettingsRequestAction } from './user-requests'

export const reatomToggleOtpQuickLogin = () => {
  const executeAction = action(async (ctx) => {
    const enabled = ctx.get(otpQuickLoginEnabledAtom)
    return updateUserSettingsRequestAction(ctx, {
      otpQuickLogin: !enabled,
    })
  })
  const toggleStateAtom = reatomRequest({
    execAction: executeAction,
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        userReceivedAction(ctx, result.success)
        return
      }
      showErrorSnackbarAction(ctx, result.failure)
    },
  })

  return toggleStateAtom
}

export const reatomToggleIncognitoMode = () => {
  const executeAction = action(async (ctx) => {
    const enabled = ctx.get(incognitoModeEnabledAtom)
    return updateUserSettingsRequestAction(ctx, {
      isIncognito: !enabled,
    })
  })
  const toggleStateAtom = reatomRequest({
    execAction: executeAction,
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        userReceivedAction(ctx, result.success)
        return
      }
      showErrorSnackbarAction(ctx, result.failure)
    },
  })

  return toggleStateAtom
}
